export interface TrialActivationConfirmContext {
  locale: string
  country?: string
}

interface TrialActivationConfirmMarket {
  id: string
  matches: (context: TrialActivationConfirmContext) => boolean
}

/**
 * IDEA-10758 currently matches Dutch UI locale. The requirement is presence in
 * the Netherlands. When we switch, compare `country` to `'NL'` — Cloudflare's
 * IP country on the `cf-country` cookie (`COUNTRY_COOKIE_NAME`).
 */
function matchesNetherlandsMarket({ locale }: TrialActivationConfirmContext): boolean {
  return locale.toLowerCase().split('-')[0] === 'nl'
}

const TRIAL_ACTIVATION_CONFIRM_MARKETS: TrialActivationConfirmMarket[] = [
  { id: 'nl', matches: matchesNetherlandsMarket },
]

export function requiresTrialActivationConfirm(context: TrialActivationConfirmContext): boolean {
  return TRIAL_ACTIVATION_CONFIRM_MARKETS.some(market => market.matches(context))
}

/**
 * Confirm before a trial converts to a paid charge: the user is in a
 * confirm-required market, still on trial, and the next action would skip the
 * trial (cost above remaining coins, or an explicit skip).
 */
export function shouldConfirmTrialActivation(input: {
  locale: string
  country?: string
  isOnTrial: boolean
  balance?: number
  coinPrice?: number
  willActivateTrial?: boolean
}): boolean {
  if (
    !input.isOnTrial ||
    !requiresTrialActivationConfirm({ locale: input.locale, country: input.country })
  ) {
    return false
  }
  if (input.willActivateTrial) {
    return true
  }
  if (input.coinPrice === undefined || input.balance === undefined) {
    return false
  }
  return input.coinPrice > input.balance
}
